module.exports = __webpack_public_path__ + "img/s11-txt7.b14464c2.png";